<template>
    <div class="countdown py-8 md:py-12 px-5">
        <div class="text-center">

            <countdown-item>
                <slot slot="value">{{days}}</slot>
                <slot slot="de">Tage</slot>
                <slot slot="en">days</slot>
            </countdown-item>

            <countdown-item>
                <slot slot="value">{{hours}}</slot>
                <slot slot="de">Stunden</slot>
                <slot slot="en">hours</slot>
            </countdown-item>

            <countdown-item>
                <slot slot="value">{{minutes}}</slot>
                <slot slot="de">Minuten</slot>
                <slot slot="en">minutes</slot>
            </countdown-item>

            <countdown-item>
                <slot slot="value">{{seconds}}</slot>
                <slot slot="de">Sekunden</slot>
                <slot slot="en">seconds</slot>
            </countdown-item>

        </div>
    </div>
</template>

<script>

    import countdownItem from '../countdown/countdownItem.vue'

    export default {
        name: 'matchcountdown',
        components: {
            countdownItem
        },
        data() {
            return {
                days: '',
                hours: '',
                minutes: '',
                seconds: ''
            }
        },

        props: {
            countdown: String
        },

        created: function() {

            var self = this;

            var now = new Date().getTime();

            var distance = (self.countdown * 1000) - now;

            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            if(days < 10){
                days = '0' + days;
            }

            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            if(hours < 10){
                hours = '0' + days;
            }

            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            if(minutes < 10){
                minutes = '0' + days;
            }

            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
            if(seconds < 10){
                seconds = '0' + seconds;
            }

            self.days = days;
            self.hours = hours;
            self.minutes = minutes;
            self.seconds = seconds;


            setInterval(function() {
                var now = new Date().getTime();

                var distance = (self.countdown * 1000) - now;

                self.days = Math.floor(distance / (1000 * 60 * 60 * 24));
                self.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                self.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                self.seconds = Math.floor((distance % (1000 * 60)) / 1000);

            }, 1000);
        }
    }
</script>


<style lang="scss">
    .countdown{
        position: relative;
        z-index: -1;
        background-color: rgba(248,178,52,0.8);
        color: #FFF;
        background-position: right;
        background-image: url(https://api.pgsi2020.de/img/bg_ornament.svg);
        background-repeat: no-repeat;
        margin-bottom: 30px;
    }
</style>
